<template>
    <div
        v-if="department"
        class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters"
    >
        <div class="kgr-grid__cell">
            <kgr-form-row
                :label="$t('Übergeordnete Abteilung')"
                :error="error"
                field-name="parentDepartment"
            >
                <kgr-department-select
                    ref="departmentSelect"
                    hide-label
                    :value="parentDepartment"
                    :club-id="clubId"
                    :default-text="defaultSelectText"
                    :excluded-ids="excludeDepartments"
                    exclude-if-basic-data-not-viewable
                    clearable
                    @post-input="onDepartmentChange"
                    @optionsLoaded="departmentOptionsLoaded"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('department.name')"
                :error="error"
                field-name="name"
                required
            >
                <input
                    v-model.trim="department.name"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('department.shortName')"
                :error="error"
                field-name="shortName"
            >
                <input
                    v-model.trim="department.shortName"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('department.dateOfFounding')"
                :error="error"
                field-name="dateOfFounding"
                :tooltip="$t('Format: TT.MM.JJJJ')"
            >
                <kgr-date-picker
                    v-model.trim="department.dateOfFounding"
                    @enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('department.dateOfClosure')"
                :error="error"
                field-name="dateOfClosure"
                :tooltip="$t('Format: TT.MM.JJJJ')"
            >
                <kgr-date-picker
                    v-model.trim="department.dateOfClosure"
                    @enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                v-if="sportsTypeNumberVisible"
                :label="$t('department.sportsTypeNumber')"
                :error="error"
                field-name="sportsTypeNumber"
            >
                <input
                    v-model.trim="department.sportsTypeNumber"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>
        </div>

        <div class="kgr-grid__cell">
            <kgr-department-image-form-row
                :department="department"
                add-style="max-width: 144px; max-height: 90px;"
            />

            <kgr-form-row
                :label="$t('department.description')"
                :error="error"
                field-name="description"
            >
                <textarea
                    v-model.trim="department.description"
                    rows="5"
                    class="kgr-input"
                ></textarea>
            </kgr-form-row>

            <kgr-form-row
                :label="$t('Sonderbeiträge für die Abteilung')"
                :error="error"
                field-name="clubFees"
            >
                <kgr-checkbox
                    v-model="department.hasClubFees"
                    :label="$t('Hinweis anzeigen, dass es für die Abteilung Sonderbeiträge gibt')"
                    class="kgr-row mt1"
                    :inactive="!department.canEditOnlineRegistration"
                    :readonly="!department.canEditOnlineRegistration"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('department.allowOnlineRegistration')"
                :error="error"
                field-name="allowOnlineRegistration"
            >
                <kgr-checkbox
                    v-model="department.allowOnlineRegistration"
                    :label="$t('department.allowOnlineRegistration')"
                    class="kgr-row mt1"
                    :inactive="!department.canEditOnlineRegistration"
                    :readonly="!department.canEditOnlineRegistration"
                />
            </kgr-form-row>
        </div>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import DatePicker from '../common/form/picker/DatePicker';
import Department from '../../js/dto/Department';
import DepartmentSelect from '../common/form/select/DepartmentSelect';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import KgrDepartmentImageFormRow from './ImageFormRow';

export default {
    name: 'KgrDepartmentBasicDataForm',
    components: {
        KgrDepartmentImageFormRow,
        'kgr-checkbox': Checkbox,
        'kgr-department-select': DepartmentSelect,
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
    },
    props: {
        departmentInput: {
            type: Department,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            departmentOptions: [],
            loading: true,
            department: null,
        };
    },
    computed: {
        parentDepartment() {
            return this.departmentOptions.find((department) => this.department.parentDepartmentId !== null && department.id === this.department.parentDepartmentId);
        },
        defaultSelectText() {
            return `- ${this.$t('Keine')} -`;
        },
        excludeDepartments() {
            return [this.department.id].concat(this.department.childDepartmentIds);
        },
        sportsTypeNumberVisible() {
            return !(window.kgr.hiddenFeatures || []).includes('department.sportsTypeNumber');
        },
    },
    mounted() {
        this.department = this.departmentInput;
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
        onDepartmentChange(department) {
            this.department.parentDepartmentId = department === null ? null : department.id;
        },
        reload() {
            this.$refs.departmentSelect.reload();
        },
        departmentOptionsLoaded($event) {
            this.departmentOptions = $event;
            this.loading = false;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
